import { defineComponent as _defineComponent } from 'vue'
import { onMounted, computed } from 'vue-demi';

interface Props {
  placeholder?: string;
  modelValue: any;
  options: {
    value: any;
    text: string;
  }[];
}
interface Emits {
  (e: 'update:modelValue', data: any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbSelect',
  props: {
    placeholder: null,
    modelValue: null,
    options: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', data: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  placeholder?: string;
  modelValue: any;
  options: {
    value: any;
    text: string;
  }[];
};



const localValue = computed({
  get() {
    return props.modelValue;
  },
  set(newVal) {
    emit('update:modelValue', newVal);
  },
});

const handleChange = (e: any) => {
  localValue.value = e.target?.value;
};
onMounted(async () => {
  if (typeof window !== 'undefined') {
    await import('@shoelace-style/shoelace/dist/components/select/select');
    await import('@shoelace-style/shoelace/dist/components/option/option');
  }
});

return { __sfc: true,props, emit, localValue, handleChange }
}

})